import { render, staticRenderFns } from "./BoothComp.vue?vue&type=template&id=fb202b42"
import script from "./BoothComp.vue?vue&type=script&lang=ts"
export * from "./BoothComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports